export const compareTwoArraysAndRemoveObjectWithEqualKeyValues = <T, U>(
  keyName: string,
  arrayToFilter?: T[] | null,
  arrayToCompare?: (T | U)[] | null,
) => {
  if (!arrayToFilter || !arrayToCompare) return [];
  const keysSet = new Set(arrayToCompare.map((obj) => obj[keyName]));
  const filteredArray = arrayToFilter.filter((obj) => !keysSet.has(obj[keyName]));
  return filteredArray;
};
